import React, { useEffect, useState } from 'react'
import { ConfiaCarContainer } from 'src/components/confiacar/container'
import { ConfiaCarRow } from 'src/components/confiacar/Row'
import { ConfiaCarCol } from 'src/components/confiacar/Col'
import { ConfiaCarCardGroup } from 'src/components/confiacar/Card/CardGroup'
import { ConfiaCarCard, ConfiaCarCardBody } from 'src/components/confiacar/Card'
import {
  ConfiaCarForm,
  ConfiaCarInputGroup,
  ConfiaCarInputPassword,
} from 'src/components/confiacar/Form'
import { ConfiaCarButton } from 'src/components/confiacar/Button'
import { useAuth } from 'src/contexts/authContext'
import { useLocation } from 'react-router-dom'

const ChangePassword = () => {
  const [payload, setPayload] = useState('')
  const [avaliabeChange, setAvaliabeChange] = useState(false)
  const { changePassword } = useAuth()
  const location = useLocation()

  const handelFormData = (event) => {
    const { id, value } = event
    setPayload((prev) => ({
      ...prev,
      [id]: value,
    }))
  }

  useEffect(() => {
    setAvaliabeChange(payload.newPassword === payload.confirmNewPassword)
  }, [payload])

  const requestPasswordRecovery = async () => {
    await changePassword({
      hash: location?.search.replace('?key=', ''),
      password: payload.newPassword,
      confirmPassword: payload.confirmNewPassword,
    })
  }

  return (
    <div className="bg-primary min-vh-100 d-flex flex-row align-items-center">
      <ConfiaCarContainer>
        <ConfiaCarRow className="justify-content-center">
          <ConfiaCarCol md={8}>
            <ConfiaCarCardGroup>
              <ConfiaCarCard className="p-4">
                <ConfiaCarCardBody>
                  <ConfiaCarForm>
                    <h1>Alterar senha</h1>
                    <p className="text-medium-emphasis">Informe a nova senha</p>
                    <ConfiaCarInputGroup className="mb-3">
                      <ConfiaCarInputPassword
                        id="newPassword"
                        type="password"
                        placeholder="Nova senha"
                        value={payload.newPassword}
                        onChange={(event) => handelFormData(event.target)}
                      />
                    </ConfiaCarInputGroup>
                    <ConfiaCarInputGroup className="mb-3">
                      <ConfiaCarInputPassword
                        id="confirmNewPassword"
                        type="password"
                        placeholder="Confirmar nova senha"
                        value={payload.confirmNewPassword}
                        onChange={(event) => handelFormData(event.target)}
                      />
                    </ConfiaCarInputGroup>
                    <ConfiaCarRow>
                      <ConfiaCarCol>
                        <div className="d-grid gap-2">
                          <ConfiaCarButton
                            disabled={!avaliabeChange}
                            onClick={() => requestPasswordRecovery()}
                          >
                            Alterar
                          </ConfiaCarButton>
                        </div>
                      </ConfiaCarCol>
                    </ConfiaCarRow>
                  </ConfiaCarForm>
                </ConfiaCarCardBody>
              </ConfiaCarCard>
            </ConfiaCarCardGroup>
          </ConfiaCarCol>
        </ConfiaCarRow>
      </ConfiaCarContainer>
    </div>
  )
}

export default ChangePassword
